<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card title="Create a new user">
          <form @submit.prevent="createUser()">
            <label>Username</label>
            <fieldset class="form-group">
              <input 
                type="text"
                class="form-control form-control-lg"
                :value="generatedUsername"
                disabled
              />
            </fieldset>

            <label>Name</label>
            <fieldset class="form-group ">
              <input 
                type="text"
                class="form-control form-control-lg"
                placeholder=""
                v-model="user.name"
              />
            </fieldset> 

            <label>Email</label>
            <fieldset class="form-group">
              <input 
                type="email"
                class="form-control form-control-lg"
                placeholder="email"
                v-model="user.email"
                required
              />
            </fieldset>

            <label>Phone</label>
            <fieldset class="form-group ">
              <input 
                type="text"
                class="form-control form-control-lg"
                placeholder=""
                v-model="user.phone"
              />
            </fieldset>

            <label>Password</label>
            <fieldset class="form-group">
              <input 
                type="password"
                class="form-control form-control-lg"
                placeholder="password"
                v-model="user.password"
                required
              />
            </fieldset>

            <label>Grant Access</label>
            <fieldset class="form-group">
              <ul class="user-access-list">
                <li>
                  <label for="assets"><input type="checkbox" id="assets" v-model="user.access" value="assets"> Assets</label>
                </li>
                <li>
                  <label for="pages"><input type="checkbox" id="pages" v-model="user.access" value="pages"> Pages</label>
                </li>
                <li>
                  <label for="navigation"><input type="checkbox" id="navigation" v-model="user.access" value="navigation"> Navigation</label>
                </li>
                <li>
                  <label for="live"><input type="checkbox" id="live" v-model="user.access" value="live"> Live</label>
                </li>
                <li>
                  <label for="settings"><input type="checkbox" id="settings" v-model="user.access" value="settings"> Settings</label>
                </li>
                <li>
                  <label for="user"><input type="checkbox" id="user" v-model="user.access" value="user"> Create / Update Users</label>
                </li>
                <li>
                  <label for="email"><input type="checkbox" id="email" v-model="user.access" value="email-properties"> Backend Email Properties</label>
                </li>
              </ul>
            </fieldset>
            <fieldset class="form-group">
              <input 
                type="submit"
                class="btn btn-primary"
                value="Create User"
              />
            </fieldset>
          </form>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import store from '@/store'
import { USER_CREATE } from '@/store/actions.type'
import _ from 'lodash'

export default {

  name: 'CreateUser',

  data() {
    return {
      user: {
        access: [],
        email: '',
        name: '',
        password: '',
        phone: ''
      }
    };
  },

  computed: {
    generatedUsername () {
      return _.toLower(_.camelCase(this.user.name))
    }
  },

  methods: {
    logout() {
      this.$store.dispatch(LOGOUT).then(() => {
        this.$router.push({ name: 'login' })
      });
    },

    createUser() {
      this.$store.dispatch(USER_CREATE, { ...this.user, username: this.generatedUsername })
        .then(res => {
          this.$notify({
            message: 'Created user: ' + res.data.user.email,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'success'
          })
          this.$router.push('/users')
        })
        .catch(err => {
          this.$notify({
            message: 'Create user failed',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          })
        })
    }
  }
};
</script>
<style lang="scss" scoped>
.user-access-list {
  list-style: none;
  padding: 0 16px;

  li {
    label {
      font-size: 14px;
      user-select: none;
    }
  }
}
</style>
